<template>
  <div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mb-4 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="popupNuevoComntarioActivo=true">Nuevo...</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelar">Cancelar</vs-button>
        </div>
      </div>
    </div>

    <vx-card card-border title="Comentarios de la operación" title-color="dark" collapseAction>
      <div v-if="timelineData.length>0">
        <ul class="vx-timeline">
          <li v-for="item in timelineData" :key="item.id">
            <div class="vx-row mb-4">
              <div class="vx-col sm:w-12/12 w-full">
                <div class="timeline-icon" :class="`bg-${item.color}`">
                    <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
                </div>
                <div class="timeline-info fondoComentario">
                  <div class="mb-2">
                    <p class="textoOperacionComentarioDateTime">{{ item.time }}</p>
                  </div>
                  <div class="mb-2">
                    <p class="textoOperacionComentarioProducto">{{ item.title }}</p>
                  </div>
                  <div class="mb-2">
                    <span class="textoOperacionComentario">{{ item.desc }}</span>
                  </div>
                </div>
              </div>
              <!-- <div class="vx-col sm:w-1/12 w-full">
                <feather-icon class="hover:text-primary cursor-pointer" svgClasses="w-6 h-6" icon="Trash2Icon"  v-if="item.borrar" @click="confirmacionBorrado(item.id)"/>
              </div> -->
            </div>
          </li>
        </ul>
      </div>
      <div v-else>
        <vs-alert color="danger" icon-pack="feather" icon="icon-info">
          <span>No se ha creado ningún comentario asociado a la operación.</span>
        </vs-alert>
      </div>
    </vx-card>

    <!-- Popup New Comentario -->
    <vs-popup title="Añadir comentario" :active.sync="popupNuevoComntarioActivo" button-close-hidden >
      <div class="vx-row mb-2">
        <div class="vx-col w-full mb-4">
          <div>
            <span>Producto</span>
          </div>
          <div>
            <v-select class="w-full" 
              v-model="producto" 
              :options="productos" 
              label="producto"
              :reduce="id => id.id" 
            />
          </div>
        </div>
        <div class="vx-col w-full">
          <div>
            <span class="campoObligatorio">Comentario *</span>
          </div>
          <div>
            <vs-textarea class="w-full" data-vv-as="COMENTARIO" name="comentario" v-validate="'required'" v-model="comentario" height="120px" @input="v => { comentario = v.toUpperCase()}"/>
            <span class="text-danger text-sm"  v-show="errors.has('direccionCliente')">{{ errors.first('direccionCliente') }}</span>
          </div>
        </div>
      </div>

      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="guardarComentario" :disabled="!validateForm">Guardar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="popupNuevoComntarioActivo=false">Cancelar</vs-button>
      </div>
    </vs-popup>

    <!-- Popup New Comentario -->
    <vs-popup title="Borrar comentario" :active.sync="popupConfirmacionBorrarComentario" button-close-hidden >
      <span>
        ¿Seguro que desea borrar el comentario?
      </span>

      <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" @click="borrarComentario">Aceptar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="popupConfirmacionBorrarComentario=false">Cancelar</vs-button>
      </div>
    </vs-popup>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-4 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="popupNuevoComntarioActivo=true">Nuevo...</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="cancelar">Cancelar</vs-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import comentariosStore from '@/store/gestion/comentarios/index.js'

import vSelect from 'vue-select'

export default {
  name: 'OperacionesEditComentarios',
  components: {
    vSelect
  },
  data () {
    return {
      usuario: null,
      operacion: {},
      comentarios: {},
      productos: {},
      producto: null,
      comentario: null,
      comentarioBorrarId: null,
      popupNuevoComntarioActivo: false,
      popupConfirmacionBorrarComentario: false
    }
  },
  computed: {
    validateForm () {
      if (this.errors.any() || this.comentario === null || this.comentario === undefined) {
        return false
      } else {
        return true
      }
    },
    timelineData () {
      const c = []
      this.comentarios.forEach(element => {
        const e = {}
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }
        e.id = element.id
        e.borrar = element.usuario.id === this.usuario.uid 
        e.color = element.producto ? 'success' : 'warning'
        e.icon = element.producto ? 'ShoppingCartIcon' : 'BookOpenIcon'
        e.title = element.producto ? element.producto.producto : '---'
        e.desc = element.comentario
        e.time = `${new Date(element.fecha).toLocaleDateString('es-ES', options)} por ${element.usuario.apellidos}, ${element.usuario.nombre}`
        c.push(e)
      })
      return c
    }
  },
  methods: {
    cancelar () {
      this.$router.push({name: 'operaciones'})
    },
    async guardarComentario () {
      let errorAlGuardar = false
      this.popupNuevoComntarioActivo = false
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      const utc = new Date().toLocaleString('en', {timezone: 'Europe/Madrid'})
      const ahora = new Date(utc)
      const c = {}
      c.operacion = `/api/operacions/${this.operacion.id}`
      c.usuario = `/api/usuarios/${this.usuario.uid}`
      c.producto = this.producto ? `/api/productos/${this.producto}` : null
      c.fecha = `${ahora.getFullYear()}-${ahora.getMonth() + 1}-${ahora.getDate()} ${ahora.getHours()}:${ahora.getMinutes()}:${ahora.getSeconds()}` 
      c.comentario = this.comentario

      await this.$store.dispatch('comentariosStore/addComentario', c)
        .then(() => {})
        .catch((error) => {
          this.showError(error)
          errorAlGuardar = true
        })

      await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
        .then((response) => {
          this.operacion = JSON.parse(JSON.stringify(response.data))
          this.comentarios = JSON.parse(JSON.stringify(this.operacion.comentarios))
          this.comentarios.sort((a, b) => { return new Date(b.fecha) - new Date(a.fecha)})
        })
        .catch((error) => {
          this.showUpdateError(error)
          errorAlGuardar = true
        })
      
      if (!errorAlGuardar) {
        this.producto = null
        this.comentario = null
        this.showSuccess('COMENTARIO GUARDADO', 'El comentario se ha añadido a la operación correctamente.')
      }
    },
    confirmacionBorrado (id) {
      this.comentarioBorrarId = id
      this.popupConfirmacionBorrarComentario = true
    },
    async borrarComentario () {
      let errorAlBorrar = false
      this.popupConfirmacionBorrarComentario = false
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

      await this.$store.dispatch('comentariosStore/deleteComentario', this.comentarioBorrarId)
        .then(() => {})
        .catch((error) => {
          this.showError(error)
          errorAlBorrar = true
        })

      await this.$store.dispatch('operacionesStore/getOperacion', this.operacion.id)
        .then((response) => {
          this.operacion = JSON.parse(JSON.stringify(response.data))
          this.comentarios = JSON.parse(JSON.stringify(this.operacion.comentarios))
          this.comentarios.sort((a, b) => { return new Date(b.fecha) - new Date(a.fecha)})
        })
        .catch((error) => {
          this.showUpdateError(error)
          errorAlBorrar = true
        })
      
      if (!errorAlBorrar) this.showSuccess('COMENTARIO BORRADO', 'El comentario ha sido borrado correctamente.')
    },
    showSuccess (titulo, texto) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: titulo,
        text: texto
      })
    },
    showError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: error
      })
    }
  },
  created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!comentariosStore.isRegistered) {
      this.$store.registerModule('comentariosStore', comentariosStore)
      comentariosStore.isRegistered = true
    }

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    this.comentarios = JSON.parse(JSON.stringify(this.operacion.comentarios))
    this.comentarios.sort((a, b) => { return new Date(b.fecha) - new Date(a.fecha) })
    this.productos = JSON.parse(JSON.stringify(this.operacion.productos))
    this.usuario = JSON.parse(sessionStorage.getItem('userInfo'))
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>